// export const serverIp = '121.36.82.35'


// export const serverIp = '127.0.0.1'

export const serverHost = 'https://ndyy.ncu.edu.cn/api'
export const serverIp = '222.204.7.112'